import { GetFileResponse } from './file';

export interface CreateAlertParams {
  title: string;
}

export interface CreateAlertRequest {
  reportId: number;
  params: CreateAlertParams;
}

export interface UpdateAlertRequest {
  reportId: number;
  alertId: string;
  params: CreateAlertParams;
}

export interface DeleteAlertRequest {
  reportId: number;
  alertId: string;
}

export interface ReportNote {
  id: string;
  isNew: boolean;
  note: string;
  location: ReportLocationEnum;
  createdAt: string;
  updatedAt: string;
  flag: boolean;
  updatedByUser: any;
}

export interface ReportImage {
  id: string;
  image: any;
  location: ReportLocationEnum;
  createdAt: string;
}

export interface ReportImageWithFile extends ReportImage {
  file: GetFileResponse;
}

export interface AlertResponse {
  alert: Alert;
}

export interface Alert {
  id: string;
  title: string;
  notes: Array<ReportNote>;
  images: Array<ReportImage>;
  createdAt: string;
  updatedAt: string;
}

export enum ReportLocationEnum {
  Alert = 'ALERT',
  MonitoredValues = 'MONITORED_VALUES',
  BatteryStatus = 'BATTERY_STATUS',
  Transmission = 'TRANSMISSION',
  Comment = 'COMMENT'
}

export interface AddImageToAlertRequest {
  transmissionReportId: number;
  alertId: string;
  transmissionReportAddAlertImageParams: AddImageParams;
}

export interface RemoveImageFromAlertRequest {
  transmissionReportId: number;
  alertId: string;
  imageId: string;
}

export interface AddImageParams {
  fileId: string;
}

export interface AddImageToAlertResponse {
  image: ReportImage;
}

export interface ReportImage {
  id: string;
  image: any;
  location: ReportLocationEnum;
  alert: Alert | null;
  createdAt: string;
}

export interface UpdateNoteParams {
  note: string;
  location: ReportLocationEnum;
  alertId?: string;
  updatedByUser?: any;
  updatedAt?: string;
}

export interface UpdateMultipleNotesRequest {
  transmissionReportId: number;
  notes: Array<UpdateNoteParams>;
}

export interface UpdateMultipleNotesResponse {
  notes: Array<ReportNote>;
}
